module.exports = __webpack_public_path__ + "img/400.f35b6078.png";